// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;The sharp arrows of a warrior,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;tempered in burning coals!<br> </p> </div></div>";
// Exports
module.exports = code;